export default __webpack_public_path__ + "static/media/yearkad.abbcaafd.png";